import {
  SELECTABLE_EXPORT_FIELDS,
  SELECTABLE_EXPORT_SORT_OPTIONS,
  stringifyUTF8
} from "@/helpers/eventHelper";
import { isEqual } from "lodash";

export default {
  data: () => ({
    SELECTABLE_EXPORT_FIELDS,
    SELECTABLE_EXPORT_SORT_OPTIONS
  }),
  props: [
    "isOpen",
    "selectedExportFields",
    "exportSortOptions",
    "buttonText",
    "showConfigs"
  ],
  model: {
    prop: "isOpen",
    event: "close"
  },
  async mounted() {
    if (!this.exportSortOptions) {
      return;
    }
    await this.$store.dispatch("getEventsConfig");
    this.cPrimarySortOption = SELECTABLE_EXPORT_SORT_OPTIONS.find(
      sortOption => sortOption.default
    ).id;
  },
  methods: {
    toggleAllSelected() {
      this.cSelectedExportFields = this.areAllSelected
        ? []
        : this.allSelectableExportFields;
    },
    removeConfig() {
      this.cSelectedExportFields = [];
    },
    getSortOptionById(id) {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.find(
        sortOption => id === sortOption.id
      );
    },
    getOwnChannelExportField(channel) {
      return {
        title: `${channel.title}-Felder_Veranstaltung`,
        id: `${channel.title}-Veranstaltung`,
        children: [
          {
            title: `${channel.title}_Beschreibung`,
            id: `${channel.title}_Beschreibung`,
            getValue: event =>
              stringifyUTF8(
                event.moment?.alternative_content?.[channel.value]
                  ?.description ||
                  event.alternative_content?.[channel.value]?.description
              )
          },
          {
            title: `${channel.title}_Kurzbeschreibung`,
            id: `${channel.title}_Kurzbeschreibung`,
            getValue: event =>
              stringifyUTF8(
                event.moment?.alternative_content?.[channel.value]
                  ?.short_description ||
                  event.alternative_content?.[channel.value]?.short_description
              )
          }
        ]
      };
    }
  },
  computed: {
    allSelectableExportFields() {
      if (this.ownChannels?.length) {
        this.ownChannels.forEach(channel => {
          if (
            !this.SELECTABLE_EXPORT_FIELDS.find(
              field => field.title === `${channel.title}-Felder_Veranstaltung`
            )
          ) {
            const indexOfLastStandardChannel = this.SELECTABLE_EXPORT_FIELDS.findIndex(
              field => field.title === "Print2_Felder_Veranstaltung"
            );
            const ownChannelExportField = this.getOwnChannelExportField(
              channel
            );
            this.SELECTABLE_EXPORT_FIELDS.splice(
              indexOfLastStandardChannel + 1,
              0,
              ownChannelExportField
            );
          }
        });
      }
      const nestedIds = this.SELECTABLE_EXPORT_FIELDS.map(field =>
        field.children.map(child => child.id)
      );
      return nestedIds.flatMap(array => array);
    },
    cSelectedExportFields: {
      get() {
        return this.selectedExportFields;
      },
      set(value) {
        const exportIds = this.allSelectableExportFields.filter(id =>
          value?.includes(id)
        );
        this.$emit("setSelectedExportFields", exportIds);
      }
    },
    cIsOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("close", value);
      }
    },
    channels() {
      return this.$store.state.eventConfig?.channels ?? [];
    },
    ownChannels() {
      return this.$store.state.eventConfig?.own_channels?.filter(channel =>
        this.channels.includes(channel.value)
      );
    },
    areAllSelected() {
      return isEqual(this.selectedExportFields, this.allSelectableExportFields);
    },
    exportConfigs() {
      return this.$store.state.selectedPrincipal?.exportConfigs ?? [];
    },
    cPrimarySortOption: {
      get() {
        return this.exportSortOptions.primary;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.primary = sortOption;
      }
    },
    cSecondarySortOption: {
      get() {
        return this.exportSortOptions.secondary;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.secondary = sortOption;
      }
    },
    cThirdSortOption: {
      get() {
        return this.exportSortOptions.third;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.third = sortOption;
      }
    },
    cFourthSortOption: {
      get() {
        return this.exportSortOptions.fourth;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.fourth = sortOption;
      }
    },
    cFifthSortOption: {
      get() {
        return this.exportSortOptions.fifth;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.fifth = sortOption;
      }
    },
    selectablePrimarySortOptions() {
      if (!this.cSecondarySortOption) {
        return this.SELECTABLE_EXPORT_SORT_OPTIONS;
      }
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cThirdSortOption?.id
      );
    },
    selectableSecondarySortOptions() {
      if (!this.cThirdSortOption?.id)
        return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
          sortOption => sortOption.id !== this.cPrimarySortOption?.id
        );
      else
        return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
          sortOption =>
            sortOption.id !== this.cPrimarySortOption?.id &&
            sortOption.id !== this.cThirdSortOption?.id
        );
    },
    selectableThirdSortOptions() {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cPrimarySortOption?.id &&
          sortOption.id !== this.cSecondarySortOption?.id
      );
    },
    selectableFourthSortOptions() {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cPrimarySortOption?.id &&
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cThirdSortOption?.id
      );
    },
    selectableFifthSortOptions() {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cPrimarySortOption?.id &&
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cThirdSortOption?.id &&
          sortOption.id !== this.cFourthSortOption?.id
      );
    }
  }
};
